import Download from './download';
import { TAO_KOE } from '../libs';

class DownloadTags {
	skip = false;

	constructor() {
		window.addEventListener( 'hashchange', () => this.onHashChange() );
		this.onHashChange();
	}

	filterTag( tag = 0 ) {
		Download.forEachInstance( ( instance ) => {
			const figureEls = instance.getFigureEls();
			figureEls.forEach( ( figureEl ) => {
				const hasTag = 'none' === tag || 0 === tag || figureEl.querySelector( '[data-tag="' + tag + '"]' );
				figureEl.classList.toggle( 'en_hidden', ! hasTag );
			} );

			return instance.onChange();
		} );
	}

	replaceHash( hash, replace ) {
		const method = replace ? 'replaceState' : 'pushState';

		if ( method in window.history ) {
			this.skip = true;
			window.history[ method ].call( window.history, '', document.title, document.location.pathname + document.location.search + hash );
			this.skip = false;
		} else {
			this.skip = true;
			document.location.hash = hash;
			this.skip = false;
		}
	}

	onHashChange() {
		let tag;

		if ( this.skip ) {
			return;
		}

		if ( -1 !== document.location.hash.indexOf( '#tag=' ) ) {
			tag = document.location.hash.replace( '#tag=', '' );

			if ( 'none' === tag ) {
				this.replaceHash( '', true );
			}

			this.filterTag( tag );
		} else if ( '' === document.location.hash ) {
			this.filterTag();
		}
	}

	static instance = null;
	static getInstance() {
		DownloadTags.instance ??= new DownloadTags();
	}
}

TAO_KOE.ready( 'download-tags.js', () => DownloadTags.getInstance() );

// Expose.
Download.Tags = DownloadTags;

// Export.
export default DownloadTags;
